import { Entity } from '@backstage/catalog-model';

export const hasRepositoryConfirmedOwner = (entity: Entity) =>
  entity.kind.toLocaleLowerCase() === 'repository' &&
  entity.metadata.annotations?.['tomtom.com/ownership-status'] === 'confirmed';
